export default "__VITE_ASSET__37erlFps__"